var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405.891,
    height: 512,
    viewBox: "0 0 405.891 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-363 -395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "approval",
    d: "M215,492a20,20,0,0,1-20,20H80A80.089,80.089,0,0,1,0,432V80A80.089,80.089,0,0,1,80,0H325.891a80.092,80.092,0,0,1,80,80V292a20,20,0,0,1-40,0V80a40.047,40.047,0,0,0-40-40H80A40.047,40.047,0,0,0,40,80V432a40.047,40.047,0,0,0,40,40H195a20,20,0,0,1,20,20Zm90.891-372h-206a20,20,0,0,0,0,40h206a20,20,0,0,0,0-40Zm20,100a20,20,0,0,0-20-20h-206a20,20,0,0,0,0,40h206A20,20,0,0,0,325.891,220Zm-226,60a20,20,0,0,0,0,40H225a20,20,0,0,0,0-40Zm0,0",
    transform: "translate(363 395)",
    fill: "#e54451"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "close-cross",
    transform: "translate(597 734.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M115.05,85.943l50.811-50.807a20.581,20.581,0,0,0-29.1-29.109L85.946,56.843,35.134,6.028A20.581,20.581,0,1,0,6.03,35.136L56.837,85.943,6.03,136.751a20.581,20.581,0,0,0,29.1,29.109l50.811-50.807,50.811,50.811a20.581,20.581,0,1,0,29.1-29.109Z",
    transform: "translate(0 0)",
    fill: "#e54451"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.bdda8e73.svg";
export { ForwardRef as ReactComponent };